import React from 'react';
import './FilterBar.css';

const FilterBar = ({
  searchQuery,
  onSearchChange,
  filters,
  onFiltersChange,
  species,
  genders,
  affiliations,
}) => {
  const handleFilterChange = (filterType, value) => {
    onFiltersChange({
      ...filters,
      [filterType]: value,
    });
  };

  return (
    <div className="filter-bar">
      <div className="search-container">
        <input
          type="text"
          placeholder="Search characters..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="search-input"
        />
      </div>
      <div className="filter-container">
        <div className="filter-group">
          <label htmlFor="species-filter">Species:</label>
          <select
            id="species-filter"
            value={filters.species}
            onChange={(e) => handleFilterChange('species', e.target.value)}
            className="filter-select"
          >
            <option value="all">All Species</option>
            {species.map((spec) => (
              <option key={spec} value={spec}>
                {spec}
              </option>
            ))}
          </select>
        </div>
        <div className="filter-group">
          <label htmlFor="gender-filter">Gender:</label>
          <select
            id="gender-filter"
            value={filters.gender}
            onChange={(e) => handleFilterChange('gender', e.target.value)}
            className="filter-select"
          >
            <option value="all">All Genders</option>
            {genders.map((gender) => (
              <option key={gender} value={gender}>
                {gender}
              </option>
            ))}
          </select>
        </div>
        <div className="filter-group">
          <label htmlFor="affiliation-filter">Affiliation:</label>
          <select
            id="affiliation-filter"
            value={filters.affiliation}
            onChange={(e) => handleFilterChange('affiliation', e.target.value)}
            className="filter-select"
          >
            <option value="all">All Affiliations</option>
            {affiliations.map((affil) => (
              <option key={affil} value={affil}>
                {affil}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;

